<template>
  <div class="bg">
     <tabs :id='1'></tabs>
     <div class="banner">
      <div class="content" style="text-align:left">
        <div class="banner_title">团队线上运动平台</div>
        <div class="banner_info">在趣动WillGo和4亿职工开启品质健康生活</div>
        <div class="flex" style="justify-content: flex-start;margin-top:39px">
          <div class="banner_num">
            <div style="margin-top:75px;position:relative">
              <animate-number from="1" to="10" duration="1000" easing="easeOutQuad" ></animate-number><span class="wan">万</span> <span class="icon_banner">+</span></div>
            <div class="banner_num_info">机构组织及事业单位</div>
          </div>
           <div class="banner_num banner_num_r">
            <div style="margin-top:75px;position:relative"><animate-number from="1" to="13" duration="1200" easing="easeOutQuad" ></animate-number><span class="wan">万</span> <span class="icon_banner">+</span></div>
            <div class="banner_num_info">服务运动团</div>
          </div>
        </div>
      </div>
     </div>
     <div class="box">
       <div class="content">
          <div class="title">团队活动用趣动</div>
          <div class="info">机关、企事业单位等各类组织的活动好帮手</div>
          <div class="box-right">
            <div style="width:560px;float:right">
               <div class="box-logo">
                <img src="../assets/img/logo3.png" alt="">
               </div>
               <div class="box-info">
                <p>国家四部委指导项目“全国职工健康促进工程”（健康运动）线上平台</p>
                <p>中华全国总工会宣传教育部“全国职工线上健身运动平台”</p>
                <p>中华全国总工会宣传教育部“全国职工线上运动会”赛事平台</p>
               </div>
               <div class="flex box-icon flex_between align-top">
                <div>
                  <img src="../assets/img/icon1_index.png" alt="">
                  <div class="icon_name" style="margin-top:14px">省/市/区<br>工会系统</div>
                </div>
                 <div>
                  <img src="../assets/img/icon2_index.png" alt="">
                  <div class="icon_name">产业/行业</div>
                </div>
                <div>
                  <img src="../assets/img/icon3_index.png" alt="">
                  <div class="icon_name">协会组织</div>
                </div>
                <div>
                  <img src="../assets/img/icon4_index.png" alt="">
                  <div class="icon_name">机关部委</div>
                </div>
                <div>
                  <img src="../assets/img/icon5_index.png" alt="">
                  <div class="icon_name">单位/团队</div>
                </div>
               </div>
            </div>   
          </div>
          <div class="box-left">
           <div class="yuan_wai">
            <img src="../assets/img/bubble3.png" class="bubble3" alt="">
            <img src="../assets/img/bubble6.png" class="bubble6" alt="">
            <img src="../assets/img/bubble5.png" class="bubble5" alt="">
           </div>
           <div class="yuan_nei">
            <img src="../assets/img/bubble4.png" class="bubble4" alt="">
            <img src="../assets/img/bubble2.png" class="bubble2" alt="">
            <img src="../assets/img/bubble1.png" class="bubble1" alt="">
            <img src="../assets/img/bubble7.png" class="bubble7" alt="">

           </div>
          </div>
       </div>
     </div>
     <!-- 平台优势 -->
     <div class="box1">
          <div class="title color_white">平台优势</div>
          <div class="info color_white">企业级职工活动管理服务平台</div>
          <div class="content flex" style="flex-wrap: wrap;justify-content: space-between;padding-top:48px">
           <div class="box1_big flex">
            <img src="../assets/img/icon7_index.png" alt="">
            <div class="box1_right">
              <div class="box1_title">创新性</div>
              <div class="box1_info">互联网，移动互联，物联网技术与运动健身的完美结合</div>
            </div>
           </div>
             <div class="box1_big flex">
            <img src="../assets/img/icon9_index.png" alt="">
            <div class="box1_right">
              <div class="box1_title">竞技性</div>
              <div class="box1_info">竞技不再枯燥无聊，通过竞赛的形式实现机构间、部门间、好友与同事间的轻松有趣的竞赛</div>
            </div>
           </div>
             <div class="box1_big flex">
            <img src="../assets/img/icon8_index.png" alt="">
            <div class="box1_right">
              <div class="box1_title">灵活性</div>
              <div class="box1_info">每天随时随地采集碎片运动时间与运动数据，百余种运动方式都可以录入</div>
            </div>
           </div>
            <div class="box1_big flex">
            <img src="../assets/img/icon6_index.png" alt="">
            <div class="box1_right">
              <div class="box1_title">深入性</div>
              <div class="box1_info">配合推广各类社区休闲体育活动，把全民健身活动推广的更加深入</div>
            </div>
           </div>
          </div>
     </div>
     <!-- 推荐功能 -->
     <div class="box2">
        <div class="content">
          <div class="title">推荐功能</div>
          <div class="info">有组织有指导有激励的智慧运动健康管理体系</div>
          <div class="flex" style="flex-wrap: wrap;justify-content: space-between;margin-top:50px">
            <div class="box2_big">
              <img  src="../assets/img/icon10_index.png" alt="">
              <div class="box2_title">专属企业运动团</div>
              <div class="box2_info">便捷灵活的管理平台。一键通知员工自动加入。轻松管理万人团队</div>
            </div>
            <div class="box2_big">
              <img  src="../assets/img/icon11_index.png" alt="">
              <div class="box2_title">职工趣味活动</div>
              <div class="box2_info">个人/部门PK。线上马拉松等多种活动玩法，职工参与度，满意度高</div>
            </div>
            <div class="box2_big">
              <img  src="../assets/img/icon12_index.png" alt="">
              <div class="box2_title">专业化训练课程</div>
              <div class="box2_info">个性化科学运动课程，根据身体情况个性化选择安全运动，不盲目</div>
            </div>
          </div>
             <div class="flex" style="flex-wrap: wrap;justify-content: space-between;margin-top:41px">
            <div class="box2_big">
              <img  src="../assets/img/icon13_index.png" alt="">
              <div class="box2_title">运动数据统计</div>
              <div class="box2_info">全方位活动数据统计。生成运动团及活动报告。活动效果可视化</div>
            </div>
            <div class="box2_big">
              <img  src="../assets/img/icon14_index.png" alt="">
              <div class="box2_title">职工健康激励</div>
              <div class="box2_info">企业可按需制定职工个性化活动方案，奖励方式由你决定</div>
            </div>
            <div class="box2_big">
              <img  src="../assets/img/icon15_index.png" alt="">
              <div class="box2_title">个人数据中心</div>
              <div class="box2_info">健康行为，运动及身体数据记录与统计，实时掌握身体的变化</div>
            </div>
          </div>
        </div>
     </div>
     <!-- 便捷工具 -->
     <div class="box3">
          <div class="title color_white">便捷工具</div>
          <div class="info color_white">轻松完成员工健康建设及企业文化渗透双向目标打通</div>
          <div class="content flex" style="flex-wrap: wrap;justify-content: space-between;padding-top:76px"> 
            <div class="box3_left">
              <div class="box3_title">Web管理端</div>
              <div class="box3_info">运动团后台</div>
              <div class="box3_text">
                · 智能化团队管理：企业设置及日常管理<br>
                · 发起各类活动赛事，文化运动玩法丰富<br>
                · 数据反馈统计分析，活动指标随时掌控
              </div>
            </div>
            <div class="box3_right">
              <img src="../assets/img/icon20_index.png" class="computer" alt="">
              <img src="../assets/img/icon16_index.png" alt="" class="scale" :class="eject==1?'scale4':''" >
              <img src="../assets/img/icon17_index.png" alt="" class="scale" :class="eject==1?'scale1':''" >
              <img src="../assets/img/icon19_index.png" alt="" class="scale" :class="eject==1?'scale2':''" >
              <img src="../assets/img/icon18_index.png" alt="" class="scale" :class="eject==1?'scale3':''" >
            </div>
          </div>
     </div>
     <!-- 员工移动端 -->
     <div class="box4">
        <div class="content flex" style="flex-wrap: wrap;justify-content: space-between;margin-top:86px">
          <img src="../assets/img/icon21_index.png" class="box4_left" alt="">
          <div class="box4_right">
              <div class="box3_title">员工移动端</div>
              <div class="box3_info">趣动Will Go APP</div>
              <div class="box3_text">
                · 建立运动健康档案：参加企业、协会、行业、平台等各类健康活动赛事<br>
                · 员工使用运动团执行方案并参与活动<br>
              </div>
          </div>
        </div>
     </div>
     <!-- 科技创新 -->
     <div class="box5">
       <div class="swiper_content">
          <div class="title color_white">科技创新</div>
          <div class="info color_white">将创新、专业、科技、品质作为核心服务理念，以促进全民健身、全民健康为己任</div>
          <div class="swiper">
            <swiper  class="swiper-container" ref="mySwiper" :options="swiperOption" :auto-play="true">
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate1.png" /></div><div class="swiper_name">质量管理体系认证证书</div></swiper-slide>
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate2.png" /></div><div class="swiper_name">信息安全管理证书</div></swiper-slide>
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate3.png" /></div><div class="swiper_name">WillGo Android版软著</div></swiper-slide>
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate4.png" /></div><div class="swiper_name">WillGo IOS版软著</div></swiper-slide>
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate5.png" /></div><div class="swiper_name">增值电信业务经营许可证</div></swiper-slide>
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate6.png" /></div><div class="swiper_name">信息系统安全等级保护证书</div></swiper-slide>
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate7.png" /></div><div class="swiper_name">WillGo运动论坛交友系统</div></swiper-slide>
                <swiper-slide class="swiper-item"> <div class="swiper_img"><img src="../assets/img/cate8.png" /></div><div class="swiper_name">趣动科技商标注册证</div></swiper-slide>
        
            </swiper>
          </div>
          <div class="box5_left"></div>
          <div class="box5_right"></div>
          </div>
     </div>
     <kefu></kefu>
     <bottom></bottom>
  </div>
</template>

<script>
//  import tabs from '../components/tabs'
import Tabs from '../components/tabs.vue'
import kefu from '../components/contact_us.vue'
import Bottom from '../components/bottom.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
   data(){
    return{
        swiperOption: {
        	speed: 4000, //匀速时间
          freeMode:true,
          loop: true,
          autoplay: {
          	delay:0,
          	stopOnLastSlide: false,
          	disableOnInteraction: false
          },
          slidesPerView: 7,
          loopFillGroupWithBlank: true,
          normalizeSlideIndex:true

        },
        eject:0,

    }
   },
    components:{
        Tabs,
        Swiper,
        SwiperSlide,
        Bottom,
        kefu
    },
	 mounted () {
    	window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    },
    methods:{
       	    handleScroll () {
	        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if(scrollTop>2100){
            this.eject=1
          }
	    },
    	// 滚动之前重置
    	beforeDestroy () {
      		window.removeEventListener('scroll', this.handleScroll)
    	},
    },
    created(){
     document.title='首页 - 趣动科技'
    }
}
</script>

<style scoped>
@font-face{
    font-family: 'DIN';
      src: url('~@/assets/font/DIN Alternate Bold.ttf');
}

    @keyframes access {
    0% {
      transform: rotate3d(0,0,0,0deg);
    }
    to {
      transform: rotate3d(0,0,1,360deg);
    }
  }

   @keyframes access1 {
     0% {
       transform: rotate3d(0,0,1,360deg);
     }
     to {
       transform: rotate3d(0,0,0,0);
     }
   } 
    @keyframes scale {
     0% {
      transform: scale(.2);
      opacity: 0;
      
     }
     to {
        transform: scale(2);
        opacity: 1;
     }
   } 
       @keyframes yidong {
     0% {
      margin-top: 30px;
      opacity: 0;
     }
     to {
        margin-top: 0px;
        opacity: 1;
     }
   } 
  .bg{
    /* position: relative; */
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 20px;
  }
  .bg div{
    box-sizing: border-box;
  }
  .banner{
    height: 728px;
    width: 100%;
    background: url('../assets/img/banner_index.jpg')  center center / cover no-repeat;
    padding-top:249px;

  }
  .banner_title{
    font-size: 56px;
    color: #fff;
    line-height: 78px;
    margin-bottom: 11px;
  }
  .banner_info{
    font-size: 24px;
    color: #fff;
  }
  .banner_num{
    width: 200px;
    height: 200px;
     background: url('../assets/img/bg_num_l.png')  center center/ contain no-repeat;
     font-size: 72px;
     color: #fff;
     font-weight: 600;
      font-family: 'DIN';
      text-align: center;
      position: relative;
  }
  .banner_num_r{
     background: url('../assets/img/bg_num_r.png')  center center/ contain no-repeat;
     margin-left: 60px;
  }
  .banner_num .wan{
    font-size: 20px;
    font-weight: 500;
    color: #fff;
  }
  .banner_num_info{
    font-size: 18px;
    color: #fff;
  }
 .banner_num .icon_banner{
    font-size: 32px;
    font-weight: 500;
    position: absolute;
    right: 50px;
    top: 11px;
  }
  .banner_num_r .icon_banner{
    right: 30px;
  }

  .content{
    max-width: 1180px;
    margin: 0 auto;
    position: relative;
     animation: yidong .5s ease-in-out 1 forwards;
     -webkit-animation: yidong .5s ease-in-out 1 forwards;
  }
  .flex {
       display: flex;
       align-items: center;
       justify-content: center;
   }
   .flex-1,
   .flex1 {
       flex: 1;
   }
   .flex_between{
    justify-content: space-between;
   }
   .align-top{
    align-items: flex-start;
   }

  .box{
    width: 100%;
    height: 720px;
    background: url('../assets/img/bg1_index.jpg')  center center / cover no-repeat;
    padding-top: 48px;
     box-sizing: border-box;

  }
  .title{
    font-size: 36px;
    line-height: 50px;
    font-weight: 500;
    text-align: center;
    color: #1C1F23;
  }
  .info{
    font-size: 20px;
    line-height: 28px;
    margin-top: 12px;
    text-align: center;
    color: #1C1F23;
  }
  .color_white{
    color: #fff;
   }
  .box-right{
    height: 432px;
    width: 970px;
    background-color: rgba(255, 255, 255, .3);
    float: right;
    border-radius: 8px;
    margin-top: 62px;
    padding: 50px 73px;
    box-sizing: border-box;
  }
  .box-logo img{
    display: block;
    width: 204px;
  }
  .box-info p{
    font-size: 18px;
    line-height: 25px;
    margin-top: 20px;
    text-align: left;
    color: #2B2B47;
  }
  .box-icon{
    margin-top:47px ;

  }
   .box-icon img{
    display: block;
    width: 39px;
    margin: 0 auto;
   }
   .box-icon .icon_name{
     color: #2B2B47;
     font-size: 18px;
     margin-top: 25px;
   }
   .box-left{
    height: 640px;
    width: 640px;
    background: url('../assets/img/bg2_index.png')  center center / cover no-repeat;
    position: absolute;
    left: -30px;
    top: 35px;
   }
   .yuan_wai{
    position: absolute;
    top:50%;
    left: 50%;
    margin-left: -250px;
    margin-top: -230px;
    width: 500px;
    height: 500px;
    transform: rotate3d(0,0,0,0deg);
    animation: access 90s infinite linear;
  
   }
   .yuan_wai img{
    display: block;
    position: absolute;
    transform:rotate3d(0,0,1,360deg);
    animation: access1 90s infinite linear;
   }
   .bubble3{
    width: 110px;
    top: 200px;
    left: -30px;

   }
   .bubble6{
    width: 70px;
    top: 0;
    left: 260px;
   }
   .bubble5{
    width: 95px;
    right: 66px;
    bottom: 71px;
   }
   .yuan_nei{
    position: absolute;
    top:50%;
    left: 50%;
    margin-left: -175px;
    margin-top: -155px;
    width: 350px;
    height: 350px;
      transform:rotate3d(0,0,1,360deg);
    animation: access1 90s infinite linear;
   }
   .yuan_nei img{
    display: block;
    position: absolute;
    transform:rotate3d(0,0,1,360deg);
    animation: access 90s infinite linear;
   }
   .bubble4{
    width: 130px;
    top: -23px;
    left: 15px;
   }
   .bubble2{
    width: 110px;
    top: 12px;
    right: 25px;
   }
    .bubble1{
    width: 90px;
   top: 131px;
    right: -24px;
   }
    .bubble7{
    width: 110px;
    bottom: -20px;
    right: 200px;
   }
   .box1{
    width: 100%;
    height: 634px;
    background: url('../assets/img/bg3_index.jpg')  center center / cover no-repeat;
    padding-top: 56px;
    box-sizing: border-box;
   }
   .box1_big{
    height: 168px;
    width: 573px;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom:24px ;
   }
   .box1_big img{
    display: block;
    width: 100px;
    margin-right: 20px;
    
   }
   .box1_right{
    width: 281px;
    text-align: left;
   }
   .box1_title{
    font-size: 26px;
    font-weight: 500;
    color: #1C1F23;

   }
    .box1_info{
    font-size: 14px;
    color: #666666;
   }
   .box2{
    height: 805px;
    padding-top: 64px;
    background: url('../assets/img/bg4_index.jpg')  center center / cover no-repeat;
   }
   .box2_big{
    width: 264px;
    /* margin-top: 62px; */
   }
   .box2_big img{
    display: block;
    width:145px ;
    margin: 0 auto;
   }
   .box2_title{
    color: #111111;
    font-size: 24px;
    line-height: 33px;
    margin-bottom: 10px;
   }
   .box2_info{
    font-size: 16px;
    color: #666666;
    line-height: 24px;
   }
   .box3{
      height: 741px;
      padding-top: 56px;
      background: url('../assets/img/bg5_index.jpg')  center center / cover no-repeat;
   }
   .box3_left{
      text-align: left;
   }
   .box3_title{
    font-size: 36px;
    color: #ED6A31;
    font-weight: 500;
    margin-bottom: 12px;
    background: url('../assets/img/title_bg.png') no-repeat;
    background-position: top left;
    background-size: 50px;
    padding-left: 38px;
    padding-top: 16px;
    margin-left: -38px;
    
   }
   .box3_info{
    font-size: 20px;
    color: rgba(255, 255, 255, .5);
    margin-bottom: 40px;
   }
   .box3_text{
     font-size: 16px;
     color: #fff;
     line-height: 32px;
   }
   .box3_right{
    position: relative;
    /* width: 730px; */
   }
  .box3_right .scale{
    opacity: 0;
    position: absolute;
  }
  .scale{
    display: none;
  }
   .computer{
      display: block;
      width: 760px;
   }
    .scale1{
      display: block;
        position: absolute;
        width: 95px;
        top: 30px;
        left: 30px;
        animation: scale .5s ease-in-out 1 forwards;
        -webkit-animation: scale .5s ease-in-out 1 forwards;
   } 
  .scale4{
    display: block;
        position: absolute;
        width: 68px;
        top: 180px;
        left: 155px;
        animation: scale .5s ease-in-out 1 forwards;
        -webkit-animation: scale .5s ease-in-out 1 forwards;
        animation-delay:0.4s;
        
   } 
   .scale2{
    display: block;
        position: absolute;
        width: 180px;
        right: 100px;
        top: 0;
        animation: scale .5s ease-in-out 1 forwards;
        -webkit-animation: scale .5s ease-in-out 1 forwards;
        animation-delay:1s;
   } 
  .scale3{
    display: block;
        position: absolute;
        width: 76px;
        right: 225px;
        bottom: 0;
        animation: scale .5s ease-in-out forwards;
        -webkit-animation: scale .5s ease-in-out 1 forwards;
        animation-delay:1.2s;
   } 
    .box4{
      height: 615px;
      padding-top: 85px;
      background: url('../assets/img/bg6_index.jpg')  center center / cover no-repeat;
   }
   .box4_left{
    height: 529px;
    display: block;
   }
   .box4_right{
    text-align: left;
   }
   .box5{
     height: 571px;
    background: url('../assets/img/bg7_index.jpg')  center center / cover no-repeat;
    position: relative;
    box-sizing: border-box;
    }
    .swiper_content{
      margin: 0 auto;
    max-width: 1920px;
    padding-top: 56px;
   
    position: relative;
    }
   .swiper{
    margin: 0 auto;
     margin-top: 54px;
    width: 100%;
    position: relative;

   }
   .swiper_img{
    height: 258px;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
   }
   .swiper-item img{
    width: 190px;
   }
   .swiper_name{
    margin-top: 27px;
    color: #fff;
    font-size: 16px;
   }
   .box5_left{
    position: absolute;
    left: 0;
    top: 0;
    height: 571px;
    width: 340px;
    background: linear-gradient(270deg, rgba(255,142,56,0) 0%,#FFA54A 70%, #FFA54A 100%);
    z-index: 1;
   }
  .box5_right{
    position: absolute;
    right: 0;
    top: 0;
    height: 571px;
    width: 340px;
    background: linear-gradient(90deg, rgba(255,142,56,0) 0%,#FF782D 70%, #FF782D 100%);
    z-index: 1;
   }

  .swiper>>>.swiper-wrapper {
    transition-timing-function: linear !important;
  }


</style>




// WEBPACK FOOTER //
// src/views/index.vue